import { Card } from "antd";
import React, { useEffect, useState } from "react";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import useApi from "../../../hooks/useApi";
import TableComponent from "../../common/TableComponent";

function GrievanceTable() {
  const columns = [
    {
      title: "तक्रारीचे स्वरूप",
      dataIndex: "grievance_subject",
    },
    {
      title: " गावाचे नाव",
      dataIndex: "village",
    },
    {
      title: "तपशील",
      dataIndex: "text",
    },
    {
      title: "कोणाविरुद्ध तक्रार आहे त्याचे नाव",
      dataIndex: "against_name",
    },
    {
      title: "तक्रारदाराचे नाव",
      dataIndex: "name",
    },
    {
      title: "तक्रारदाराचा संपर्क",
      dataIndex: "mobile",
    },
  ];

  const [responseData, getRequest] = useApi(
    `/admin/grievance?pageNumber=${1}`,
    null,
    API_METHODS.GET
  );

  const [tableData, setTableData] = useState();

  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    const pagination =
      responseData.pagination !== BLANK_VALUE ? responseData.pagination : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [responseData]);

  const onPaginationChange = (page) => {
    getRequest(
      null,
      API_METHODS.GET,
      `/admin/grievance?pageNumber=${page.current}`
    );
    setCurrentPage(page.current);
  };

  return (
    <Card title="Grievance">
      <TableComponent
        columns={columns}
        tableData={tableData}
        loading={responseData.isLoading}
        onPaginationChange={onPaginationChange}
        total={totalRecords}
        current={currentPage}
      />
    </Card>
  );
}

export default GrievanceTable;
